import { render, staticRenderFns } from "./SubstituteUser.vue?vue&type=template&id=d60ed5d4&scoped=true&"
import script from "./SubstituteUser.vue?vue&type=script&lang=js&"
export * from "./SubstituteUser.vue?vue&type=script&lang=js&"
import style0 from "./SubstituteUser.vue?vue&type=style&index=0&id=d60ed5d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60ed5d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d60ed5d4')) {
      api.createRecord('d60ed5d4', component.options)
    } else {
      api.reload('d60ed5d4', component.options)
    }
    module.hot.accept("./SubstituteUser.vue?vue&type=template&id=d60ed5d4&scoped=true&", function () {
      api.rerender('d60ed5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/SubstituteUser.vue"
export default component.exports